import {Component, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-svg-icons',
  templateUrl: './svg-icons.components.html'
})

export class SvgIconsComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
